import type {
  IMerchantGroupAbstract,
  IMerchantGroupAbstractNew,
} from "src/merchantgroups/objects/MerchantGroup";

export const MERCHANT_GROUP_DETAIL_VIEW_PATH: string = "/mg/:merchantGroupUUID";

export const getMerchantGroupAbstract = (
  merchantGroup: IMerchantGroupAbstract | IMerchantGroupAbstractNew,
): IMerchantGroupAbstract => {
  if ((merchantGroup as IMerchantGroupAbstract).merchantGroupUUID) {
    return merchantGroup as IMerchantGroupAbstract;
  }
  return {
    merchantGroupName: merchantGroup.merchantGroupName,
    merchantGroupUUID: (merchantGroup as IMerchantGroupAbstractNew)
      .merchantGroupUuid,
  };
};

export const getMerchantGroupDetailViewPath = (
  merchantGroup: IMerchantGroupAbstract | IMerchantGroupAbstractNew,
): string => {
  return MERCHANT_GROUP_DETAIL_VIEW_PATH.replace(
    ":merchantGroupUUID",
    getMerchantGroupAbstract(merchantGroup).merchantGroupUUID,
  );
};
